<template>
  <div :class="['customize-form-skeleton', animated && 'customize-form-skeleton-animated']">
    <div v-for="item of rows" :key="item" class="customize-form-skeleton-item">
      <div class="customize-form-skeleton-title"></div>
      <div class="customize-form-skeleton-content"></div>
      <div class="customize-form-skeleton-contentsub"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    animated: Boolean,
    rows: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss">
@keyframes skeletonMove {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.customize-form-skeleton {
  width: 100%;

  &-title {
    width: 38%;
    height: 16px;
    margin-bottom: 24px;
    background: hsla(0,0%,74.5%,.2);
    border-radius: 4px;
  }

  &-content,
  &-contentsub {
    width: 100%;
    height: 16px;
    margin-bottom: 16px;
    background: hsla(0,0%,74.5%,.2);
    border-radius: 4px;
  }

  &-contentsub {
    width: 62%;
    margin-bottom: 40px;
  }

  &-animated {
    .customize-form-skeleton-title,
    .customize-form-skeleton-content,
    .customize-form-skeleton-contentsub {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
        background-size: 400% 100%;
        animation: skeletonMove 1.4s ease infinite;
      }
    }
  }
}
</style>